import Component_Pipeline_591870d8e8aba87fd6af5c9fe7bb9c93 from "../../../../content/examples/post-process/pipeline/Pipeline";
import Devtool_Pipeline_591870d8e8aba87fd6af5c9fe7bb9c93 from "!!@devtool/loader!../../../../content/examples/post-process/pipeline/Pipeline";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_Pipeline_591870d8e8aba87fd6af5c9fe7bb9c93,
  Devtool_Pipeline_591870d8e8aba87fd6af5c9fe7bb9c93,
  DevTool,
  React
};